/**
 * "Preview" slider initialization
 * 
 * @since 1.0.0
 * @package crunchy
 */

(function($) {
	$(document).ready(function() {

		// sanity check Flickity + disabled slider
		if ( ! ( 'flickity' in $.fn ) || $( '.disable-preview-slider' ).length ) {
			return;
		}

		// set stuff
		var wrapper = $( '.preview-slider' );
		var slider  = $( '.slider', wrapper );
		var preview = $( '.preview', wrapper );

		// init slider
		$( slider ).flickity({
			wrapAround : true,
			arrowShape: { 
				x0: 10,
				x1: 60, y1: 50,
				x2: 75, y2: 35,
				x3: 40
			}
		});

		// get its data
		var sliderData = slider.data( 'flickity' );

		// grab the next slide on init and
		// slide change
		previewNext();
		slider.on( 'select.flickity', previewNext );

		
		/**
		 * Preview the slider's next slide
		 * 
		 * @since 1.0.0
		 */
		function previewNext() {

			// get the next slide object
			var nextSlide = sliderData.slides[ sliderData.selectedIndex + 1 ];

			// if we're at the end, nextSlide will be
			// undefined. Grab the first.
			if ( nextSlide === undefined ) {
				nextSlide = sliderData.slides[ 0 ];
			}

			// grab the image from the slide
			nextSlide = nextSlide.cells[0].element;
			var image = nextSlide.getElementsByTagName( 'img' )[0];

			// replace the preview image
			return replacePreview( image );
		}


		/**
		 * Replace the existing preview image
		 * 
		 * @param object  image  image element to replace
		 * 
		 * @since 1.0.0
		 */
		function replacePreview( image ) {

			// fade out & delete existing image
			$( 'img', preview ).fadeOut( 'normal', function() {
				$(this).remove();
			});

			// clone the image & hide it
			image = $( image ).clone().hide();

			// add in the new image & fade it
			preview.prepend( image );
			image.fadeIn();

			return;
		}

	}); // document.ready
})(jQuery);
